<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h6">
          Input No Laporan Kejadian
        </v-card-title>

        <v-container>
          <v-text-field
            v-model="formData.no_lk"
            label="Nomor LK"
            outlined
            hide-details
            @keydown.enter="fetchLaporanKejadian"
            :disabled="loading"
            :loading="loading"
            autofocus
          ></v-text-field>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  name: "FindKodeTTBModal",
  props: ["openModal"],
  data() {
    return {
      formData: {
        no_lk: ""
      },
      loading: false
    };
  },
  watch: {
    openModal(val) {
      if (val) {
        this.formData.no_lk = "";
      }
    },
    "formData.no_lk"(val) {
      if (val) {
        this.formData.no_lk = val.toUpperCase();
      }
    }
  },
  methods: {
    async fetchLaporanKejadian() {
      this.loading = true;

      await axios
        .get(`laporan-kejadian/${this.formData.no_lk}`)
        .then(res => {
          this.loading = false;

          this.$emit("close-modal", res.data);
        })
        .catch(err => {
          this.loading = false;

          alert(err.response.data.message);
        });
    }
  }
};
</script>
